export default __webpack_public_path__ + "static/media/rocket_anim_140.2cecfb24.png";